module.exports = __webpack_public_path__ + "static/frontUserNew/img/template-customer-standard.2bf812f7.png";